import React from 'react'
import List from './List'
import { useContractOnboardingById } from 'src/queries'

interface BodyProps {
  id: string
}

const Body: React.FC<BodyProps> = (props) => {
  const { id } = props
  const contract = useContractOnboardingById(id)
  return (
    <List contract={contract} />
  )
}

export default Body
